import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import axios from "axios";
import { baseUrl } from "../../../utils/axiosInstance";
import { setGoogleAuth } from "../../../utils/store/reducers/authSlice";

const GoogleAuth = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);
  const { contact } = useSelector((state) => state.auth);

  useEffect(() => {
    if (isAuthenticated) {
      const redirectPath =
        window.location.pathname === "/signup"
          ? "/funding-evaluation/plans/0"
          : "/";
      navigate(redirectPath);
    }
  }, [isAuthenticated, navigate]);

  const googleLogin = async () => {
    const code = searchParams.get("code");
    if (code) {
      try {
        const res = await axios.get(
          `${baseUrl}auth/google/user/profile/?code=${code}`
        );
        dispatch(setGoogleAuth(res.data));
      } catch (err) {
        navigate("/signin");
      }
    } else {
      navigate("/signin");
    }
  };

  useEffect(() => {
    googleLogin();
  }, []);

  return (
    <div
      style={{
        height: "100vh",
        color: "white",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <h3 style={{ fontFamily: "Manrope" }}>Please wait...</h3>
    </div>
  );
};

export default GoogleAuth;
